module.exports = __webpack_public_path__ + "img/ic_profile.2dccff6e.svg";